export default () => {
  const page = document.getElementById('page');
  const btnTrigger = document.getElementById('btnTrigger');
  const menuOverlay = document.getElementById('menuOverlay');
  const body = document.body;

  if (!page || !btnTrigger || !menuOverlay) {
    return;
  }

  if (btnTrigger.dataset.overlayMenuInitialized === 'true') {
    return;
  }

  btnTrigger.dataset.overlayMenuInitialized = 'true';

  const setMenuState = (isActive) => {
    btnTrigger.classList.toggle('is-active', isActive);
    page.classList.toggle('is-active', isActive);
    menuOverlay.classList.toggle('is-active', isActive);
    body.style.overflow = isActive ? 'hidden' : '';
    btnTrigger.setAttribute('aria-expanded', String(isActive));
    menuOverlay.setAttribute('aria-hidden', String(!isActive));
  };

  const toggleMenuState = () => {
    const nextState = !menuOverlay.classList.contains('is-active');
    setMenuState(nextState);
  };

  const closeMenu = () => {
    setMenuState(false);
  };

  setMenuState(false);
  btnTrigger.addEventListener('click', toggleMenuState);
  menuOverlay.querySelectorAll('a[href]').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });
};
